/**
 * Runtime limits for Mestti OPS client protection (generous, not UX-tight).
 */
/** Abort POST /chat if the AI does not accept the run in time. */
export const CONSULTORIA_CHAT_START_TIMEOUT_MS = 45_000;
/** Abort SSE if no event arrives for this long (reconnect may still apply). */
export const CONSULTORIA_SSE_IDLE_TIMEOUT_MS = 120_000;
/** Auto-stop microphone capture (client-side cap before backend 413). */
export const CONSULTORIA_MAX_RECORDING_MS = 90_000;
/** Soft size hint — stop recording when buffered audio exceeds this. */
export const CONSULTORIA_MAX_RECORDING_BYTES = 8 * 1024 * 1024;

export const CONSULTORIA_SCOPE_CHAT = 'consultoria:chat';
export const CONSULTORIA_SCOPE_ACTIONS_PROPOSE = 'consultoria:actions:propose';
export const CONSULTORIA_SCOPE_ACTIONS_APPROVE = 'consultoria:actions:approve';
export const CONSULTORIA_SCOPE_ACTIONS_VIEW = 'consultoria:actions:view';
